import { Label } from "@/components/ui/label";

interface ArtworkInformationProps {
  title: string;
  artist: string;
  creationDate?: string;
  technique?: string;
  edition: string;
  dimensions: string;
}

export function ArtworkInformation({
  title,
  artist,
  creationDate,
  technique,
  edition,
  dimensions
}: ArtworkInformationProps) {
  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-4 space-y-3">
        <h3 className="font-semibold text-lg">Artwork Information</h3>
        
        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[80px]">Title:</Label>
          <span className="font-medium">{title}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[80px]">Artist:</Label>
          <span className="font-medium">{artist}</span>
        </div>

        {creationDate && (
          <div className="flex items-center gap-2">
            <Label className="font-normal min-w-[80px]">Created:</Label>
            <span className="font-medium">{creationDate}</span>
          </div>
        )}

        {technique && (
          <div className="flex items-center gap-2">
            <Label className="font-normal min-w-[80px]">Technique:</Label>
            <span className="font-medium">{technique}</span>
          </div>
        )}

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[80px]">Edition:</Label>
          <span className="font-medium">{edition}</span>
        </div>

        <div className="flex items-center gap-2">
          <Label className="font-normal min-w-[80px]">Size:</Label>
          <span className="font-medium">{dimensions}</span>
        </div>
      </div>
    </div>
  );
}